import { NgModule } from '@angular/core';
import { MachineChartComponent } from './machine-chart.component';
import { SharedModule } from '@app/shared/shared.module';
@NgModule({
  declarations: [MachineChartComponent],
  imports: [SharedModule],
  exports: [MachineChartComponent]
})
export class MachineChartModule {}
